import { Card, Heading } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { Form, Switch } from 'antd'
import styled from 'styled-components'
import type { SwitchItem } from './utils'

type SettingsCardProps = {
  title: string
  items: SwitchItem[]
}

const SettingsCard = ({ title, items }: SettingsCardProps) => (
  <StyledCard>
    <CardHeaderContainer>
      <CardTitle level={3} weight="medium">
        {title}
      </CardTitle>
      <Divider />
      {items.map((item) => (
        <ItemContainer>
          <StyledFormItem
            colon={false}
            key={item.key}
            name={item.key}
            label={
              <ItemLabel>
                <Text>{item.label}</Text>:
              </ItemLabel>
            }
            valuePropName="checked"
          >
            <Switch />
          </StyledFormItem>
          <ItemDescription>{item.description}</ItemDescription>
        </ItemContainer>
      ))}
    </CardHeaderContainer>
  </StyledCard>
)

export default SettingsCard

const StyledFormItem = styled(Form.Item)`
  width: 160px;
  display: flex;
  align-items: center;
  .ant-form-item-control {
    margin-bottom: 0 !important;
    // this will get removed hopefully after we remove that !important from the form item
  }
`

const StyledCard = styled(Card)`
  padding: 24px;
`

const ItemLabel = styled.div`
  display: flex;
  align-items: center;
  width: 160px;
  color: ${(props) => props.theme.color.neutral.color4};
`

const ItemDescription = styled(Text)`
  margin-left: 160px;
  color: ${(props) => props.theme.color.neutral.color5};
`

const CardHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ItemContainer = styled.div``

const CardTitle = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color3};
`
